module.exports = __webpack_public_path__ + "static/img/miyu2.b60e23e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/miyu2.png
// module id = 4VHT
// module chunks = 24